class VolumeRepository {
  constructor(api) {
    this.api = api;
  }
  async show() {
    let raw = `
    SELECT * FROM CROP.VOLUME
    ORDER BY TIME ASC;
  `;
    const volume = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return volume[0];
  }

  async getLastVolumeRecord(FK_SECTOR) {
    let raw = `
      SELECT *
      FROM CROP.VOLUME
      WHERE FK_SECTOR = ${FK_SECTOR}
      ORDER BY TIME DESC
      LIMIT 1;
    `;

    const volume = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return volume[0];
  }

  async checkIfEmpty(FK_SECTOR) {
    const raw = `SELECT EXISTS (SELECT * FROM CROP.VOLUME WHERE FK_SECTOR = ${FK_SECTOR}) as isExists;`;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });
    console.log('VolumeRepository - checkIfEmpty - ', resp[0][0])
    if (resp[0].length) {
      let result = resp[0][0]
      return 'isExists' in result ? result.isExists : 0;
    }
    return;
  }

  async save(values) {
    let raw = "INSERT INTO CROP.VOLUME (FK_VALVE,FK_SECTOR,TIME,VALUE,VALUE_INPUT) VALUES" + values + ";";

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length) {
      console.log(
        `[CRON] - Sucesso ao salvar dados de volume diário`
      );
    }

    return resp;
  }
  async del(FK_SECTOR) {
    let raw = `DELETE FROM CROP.VOLUME WHERE FK_SECTOR = ${FK_SECTOR};`;
    // const resp = await knex("VOLUME")
    //   .where("FK_SECTOR", FK_SECTOR)
    //   .del();

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length) {
      console.log(`[CRON] - Sucesso ao deletar volumes do setor ${FK_SECTOR}.`);
    }

    return resp;
  }
  async deleteByInterval(FK_SECTOR,START,END) {
    let raw = `DELETE FROM CROP.VOLUME WHERE FK_SECTOR = ${FK_SECTOR} AND TIME BETWEEN '${START}' AND '${END}';`;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length) {
      console.log(`[CRON] - Sucesso ao deletar volume do setor ${FK_SECTOR} por intervalo.`);
    }
    return resp;
  }

  async deleteByTime(FK_SECTOR,START) {
    let raw = `DELETE FROM CROP.VOLUME WHERE FK_SECTOR = ${FK_SECTOR} AND TIME > '${START}';`;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length) {
      console.log(`[CRON] - Sucesso ao deletar volume do setor ${FK_SECTOR} a partir da data de colheita.`);
    }
    return resp;
  }

  async count(FK_SECTOR) {
    let raw = `SELECT COUNT(*) AS QTD FROM CROP.VOLUME WHERE FK_SECTOR = ${FK_SECTOR};
    `;
    // const resp = await knex("VOLUME")
    //   .count("* as QTD")
    //   .where("FK_SECTOR", FK_SECTOR)
    //   .first();

    const qtd = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return qtd[0][0];
  }

  async showVolumesByIdValve(FK_VALVE) {
    let raw = `SELECT * FROM CROP.VOLUME WHERE FK_VALVE = ${FK_VALVE} ORDER BY TIME ASC;`;

    // const volumes = await knex
    //   .select("*")
    //   .from("VOLUME")
    //   .where("FK_VALVE", FK_VALVE);

    const volume = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return volume;
  }
  async showVolumeByIdValveAndTime(FK_VALVE, TIME) {
    let raw = `
      SELECT * FROM CROP.VOLUME as volume
      WHERE volume.FK_VALVE = ${FK_VALVE}
      AND volume.TIME = '${TIME}'
      ORDER BY TIME ASC;
    `;
    // const volume = await knex
    //   .select("*")
    //   .from("VOLUME")
    //   .where("FK_VALVE", FK_VALVE)
    //   .andWhere("TIME", TIME)
    //   .first();

    const volume = await this.api.sql({
      data: {
        sql: raw
      }
    });


    return volume[0];
  }

  async showVolumeByIdValveAndIdSectorAndTime(FK_SECTOR, FK_VALVE, TIME) {
    let raw = `
      SELECT * FROM CROP.VOLUME as volume
      WHERE volume.FK_SECTOR = ${FK_SECTOR}
      AND volume.FK_VALVE = ${FK_VALVE}
      AND volume.TIME = '${TIME}'
      ORDER BY TIME ASC;
    `;
    // const volume = await knex
    //   .select("*")
    //   .from("VOLUME")
    //   .where("FK_VALVE", FK_VALVE)
    //   .andWhere("TIME", TIME)
    //   .first();

    const volume = await this.api.sql({
      data: {
        sql: raw
      }
    });


    return volume[0];
  }
  async getValveFirstVolumeLog(FK_SECTOR, FK_VALVE) {
    if(FK_SECTOR && FK_VALVE) {
      let raw = `
        SELECT TIME,VALUE FROM CROP.VOLUME as volume
        WHERE volume.FK_SECTOR = ${FK_SECTOR}
        AND volume.FK_VALVE = ${FK_VALVE}
        ORDER BY TIME ASC
        LIMIT 1;
      `;
  
      const volume = await this.api.sql({
        data: {
          sql: raw
        }
      });
  
  
      return volume[0];
    }

    return [];

  }
  async getVolumesSinceFirstLog(FK_SECTOR, FK_VALVE, START) {
    let raw = `
      SELECT * FROM (SELECT
        TIME,
        VALUE,
        VALUE_INPUT
      FROM
        CROP.VOLUME as volume
      WHERE
        volume.FK_SECTOR = ${FK_SECTOR}
        AND volume.FK_VALVE = ${FK_VALVE}
        ORDER BY volume.TIME ASC
        ) AS VOLUMES
      WHERE VOLUMES.TIME >= '${START}'
      ORDER BY VOLUMES.TIME ASC;
    `;

    const volume = await this.api.sql({
      data: {
        sql: raw
      }
    });


    return volume
  }
}

export {
  VolumeRepository
}
